module.exports = __webpack_public_path__ + "static/media/wifi-2.22ff1b83.svg";